/** People Landing — campos del bloque "divider". Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx. */
import { useTranslation } from 'react-i18next';
import type { EditorFieldProps } from '../types';

export function DividerFields(_props: EditorFieldProps) {
  const { t } = useTranslation();
  return (
    <p className="text-sm text-muted-foreground">
      {t('people_landing.editor.divider_hint', 'Una línea separadora horizontal.')}
    </p>
  );
}
